import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import ColumnBox from 'components/ColumnBox';
import RowBox from 'components/RowBox';

import VisibilityIcon from '@mui/icons-material/Visibility';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShortcutIcon from '@mui/icons-material/Shortcut';


import { useNavigate, createSearchParams } from 'react-router-dom';

import { apiHelper, baseUrl } from 'helpers/util'
import { notify } from 'helpers/globalFunctions';

import BigHeading from 'components/BigHeading';
import SmallHeading from 'components/SmallHeading';

export default function Form() {
    const uiBaseUrl = process.env.REACT_APP_UI_URL || window.location.origin;
    const links = [
        { "link": `${uiBaseUrl}/accomodation_booking.html`,
            "title": "FOLK Vrindavan (iPhone)" },
        { "link": `${uiBaseUrl}/accomodation_booking.html?approval=auto`,
            "title": "FOLK Vrindavan (QR Code)" },
        { "link": `${uiBaseUrl}/prasadam_counter`,
            "shortened_link": "https://tinyurl.com/prasadam-live",
            "title": "Prasadam (Live)" },
        { "link": `${uiBaseUrl}/prasadam_counter?params=eyAiZWRpdCI6IHRydWUgfQ==`,
            "shortened_link": "https://tinyurl.com/prasadam-editor",
            "title": "Prasadam (Editor)" },
        { "link": `${uiBaseUrl}/prasadam_feedback`, "title": "FPH Feedback Page" },
        { "link": "https://docs.google.com/forms/d/e/1FAIpQLSf3CU-iXqX6lsJq8bprbJfgboDnBwAIu-hnkqQhqUlieoJXCw/viewform",
            "title": "Feedback (Google Form)" },
        { "link": `${uiBaseUrl}/residency_dashboard`, "title": "Residency Dashboard" },
        { "link": `${uiBaseUrl}/manage_events`, "title": "Manage Events (FOLK App)" },
        { "link": `${uiBaseUrl}/manage_feed`, "title": "Manage Feed (FOLK App)" },
        { "link": `${uiBaseUrl}/trips_and_tours`, "title": "Manage Trips (FOLK App)" },
        { "link": `${uiBaseUrl}/search_qr_code`, "title": "FOLK QR Download" },
        { "link": `${uiBaseUrl}/training_index`, "title": "Training Index" },
    ]

    const copyLink = function(link) {
        navigator.clipboard.writeText(link);
        notify.info({ "description": "Link Copied" });
    }
    const copyShortenedLink = function(link) {
        navigator.clipboard.writeText(link);
        notify.info({ "description": "Shortened Link Copied" });
    }

    const openLink = function(link) { window.open(link, '_blank'); }

    return (
        <ColumnBox>
            <SmallHeading sx={{ alignSelf: 'center' }}>Links Page</SmallHeading>
            <RowBox sx={{ justifyContent: 'center', alignItems: 'stretch' }}>
                { links.map(l => (
                    <Box sx={{ padding: '10px', maxWidth: '45%' }}>
                        <ColumnBox sx={{ border: '2px solid black', borderRadius: '5px',
                            padding: '10px' }}>
                            <Box sx={{ width: '100%', textAlign: 'center' }}>{l.title}</Box>
                            <RowBox sx={{ width: '100%' }}>
                                <IconButton sx={{ flexGrow: 1 }} variant="outlined" color="primary"
                                    onClick={() => copyLink(l.link)}>
                                    <ContentCopyIcon />
                                </IconButton>
                                { l.shortened_link ?
                                <IconButton sx={{ flexGrow: 1 }} variant="outlined" color="primary"
                                    onClick={() => copyShortenedLink(l.shortened_link)}>
                                    <ShortcutIcon />
                                </IconButton> : <></> }
                                <IconButton sx={{ flexGrow: 1 }} variant="outlined" color="primary"
                                    onClick={() => openLink(l.link)}>
                                    <PanToolAltIcon />
                                </IconButton>
                            </RowBox>
                        </ColumnBox>
                    </Box>
                )) }
            </RowBox>
        </ColumnBox>
    );
}
